/**
 * Created by Languagenut on 18/04/2019.
 */


import React  from 'react';
import {Modal , Badge , Form , Button , Card , Row , Col , Nav , ProgressBar} from 'react-bootstrap'
import ReactDOM from "react-dom";
import Papa from 'papaparse/papaparse.min.js';
import FieldGroup from '../../FieldGroup.js'
import Alert from '../../alert.js';
import downloadCsv from 'download-csv';
import autosize from 'autosize';
import Translation from '../../../store/internationalization-store.js';

class UploadStudentsCSV extends React.Component {


    constructor(props) {
        super();
        this.props = props;
        this.state = {

        };
        this.props.data.students = [];
    }


    getStudentsLength(){
        return Object.keys(this.props.data.students).length;
    }

    format(students){

        var students = (students.split(/\n/g)||[]);

        this.props.data.students = [];

        for(var i = 0 ; i < students.length; i++){
            if((String(students[i]).trim()).length > 1) this.props.data.students.push((String(students[i]).trim()))
        }

    }

    handelAddStudents(e){
        var students = this.state.students || [];
        var studentNames = e.target.value.split(/\r?\n/);
        var uniqueStudentNames = [];

        if(Number(this.getStudentsLength()) > Number(studentNames.length - 1))
        {
            for(var key in students)
            {
                if(!students.hasOwnProperty(key)) continue;
                if(Number(key) > Number(studentNames.length - 1)) delete students[key];
                if(studentNames[Number(studentNames.length - 1)].length == 0) delete students[key];
            }
        }


        for (var idx = 0; idx < studentNames.length; idx++) {
            var name = String(studentNames[idx]).replace(/\t/g, ' ').trim();

            if (name.length > 0){
                if(!students[idx]) students[idx] = {uid:null , name:name , state:'create'};
                else
                {
                    if(String(students[idx].name).toLowerCase() != String(name).toLowerCase())
                    {
                        students[idx] = {uid:null , name:name , state:'create'};
                    }
                }
            }

            if(uniqueStudentNames.indexOf(name.toLowerCase()) == -1) uniqueStudentNames.push(name.toLowerCase());
        }

        this.props.data.studentNumber = students.length;


        this.props.data.students = students;
        this.setState({studentNumber:this.props.data.studentNumber});
    }

    render(){



        return <div style={{padding:"20px"}}>
            <br/>
                            <div >
                                <FieldGroup spellcheck="false" inputRef={ref => { this.text = ref; }} autoFocus  style={{"resize":"none"}}  as="textarea" rows="6"  onChange={this.handelAddStudents.bind(this)} id="student-name" label={Translation.get(455 , "Paste or type your class list in here, one name per line")}/>
                            </div>

                    </div>
    }


}


export default {
    name: function() {return Translation.get('17326' ,'Enter Students' )},
    icon:<i class="fa-2x fas fa-upload"></i>,
    title:null,
    onSubmit: function (done){

        if(this.props.data.students.length <= 0)
        {
            return done(new Error(Translation.get('0' ,'No Students have been added' )));
        }

        done();
    },
    onBack:function(done){
        done();
    },
    component: UploadStudentsCSV
}